import { Module } from 'vuex'

import { DashboardUseCase } from '@/application/dashboard/dashboardUseCase'
import { User } from '@/domain/entities/user/user'
import { DashboardRepository } from '@/domain/repositories/dashboard/DashboardRepository'
import { DashboardTabType } from '@/domain/value_objects/dashboard/DashboardTabType'
import { ProgramLanguageType } from '@/domain/value_objects/language/programLanguageType'

interface DashboardModalState {
  dashboardUserList: User[]
  dashboardProgramLanguage: ProgramLanguageType | 'All'
  initialDashboardUser: User | null
  courseSerial: number
  tabState: DashboardTabType
  isAddingDashboardUser: boolean
  isLoading: boolean
  error: Error | null
}

export const dashboardModalStateModule = (repository: DashboardRepository): Module<DashboardModalState, any> => {
  const usecase = new DashboardUseCase(repository)

  return {
    namespaced: true,
    state: {
      dashboardUserList: [],
      dashboardProgramLanguage: 'All',
      initialDashboardUser: null,
      courseSerial: 0,
      tabState: 'OVERVIEW',
      isAddingDashboardUser: false,
      isLoading: false,
      error: null
    },
    mutations: {
      setDashboardProgramLanguage(state, { language }: { language: ProgramLanguageType | 'All' }) {
        state.dashboardProgramLanguage = language
      },
      addDashboardUser(state, { user }: { user: User }) {
        state.dashboardUserList.push(user)
      },
      removeDashboardUserList(state) {
        state.dashboardUserList.splice(0)
      },
      removeTargetUsers(state) {
        state.dashboardUserList.splice(1)
      },
      setInitialDashboardUser(state, { user }: { user: User | null }) {
        state.initialDashboardUser = user
      },
      setCourseSerial(state, courseSerial: number) {
        state.courseSerial = courseSerial
      },
      setTabState(state, tabState: DashboardTabType) {
        state.tabState = tabState
      },
      setIsAddingDashboardUser(state, isAddingDashboardUser: boolean) {
        state.isAddingDashboardUser = isAddingDashboardUser
      },
      setIsLoading(state, isLoading: boolean) {
        state.isLoading = isLoading
      },
      setError(state, error: Error | null) {
        state.error = error
      }
    },
    actions: {
      async isExistUser({ state, commit }, { userId }: { userId: string }): Promise<User | null> {
        commit('setIsLoading', true)
        commit('setError', null)

        try {
          if (userId == '' || userId == null || userId == undefined) {
            return null
          }
          const res = await usecase.isExistUser(userId)
          return res
        } catch (e) {
          commit('setError', e)
        } finally {
          commit('setIsLoading', false)
        }
        return null
      }
    },
    getters: {
      dashboardUserList: state => state.dashboardUserList,
      dashboardProgramLanguage: state => state.dashboardProgramLanguage,
      initialDashboardUser: state => state.initialDashboardUser,
      courseSerial: state => state.courseSerial,
      tabState: state => state.tabState,
      isAddingDashboardUser: state => state.isAddingDashboardUser,
      isLoading: state => state.isLoading,
      error: state => state.error
    }
  }
}
